// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b986ab6b","239":"4d6a95d0","455":"4d4e50ad"}[chunkId] + ".chunk.js";
};